import styled from "styled-components";
import { FollowRowContainer } from "../FollowRow/styles";
export var SelectPlayerFollowsContainer = styled.div.withConfig({
  displayName: "styles__SelectPlayerFollowsContainer",
  componentId: "sc-s2fiok-0"
})(["", ":last-child{border-bottom:none;}"], FollowRowContainer);